import { createFileRoute } from '@tanstack/react-router'

import SubmissionPage from '@/components/pages/backoffice/_klb-petani/_kep/submission/containers/SubmissionPage'

export const Route = createFileRoute('/_backoffice/klb-petani/kep/submission/')(
  {
    component: SubmissionPage
  }
)
